import axios, { AxiosResponse } from 'axios';
import { ProcessesVM, WeightageVM } from '../Models/ViewModels';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL + '/api'

const headers = {
   'Accept': 'application/json',
   'Content-Type': 'application/json'
}


export const GetWeightageDetails = () => {
   return axios.get(api_url + '/WeightageMaster/GetWeightageDetails');
}


export const EditWeightage = (editprr: WeightageVM, loginId: any) => {
   const payload = {
      "WeightageID": editprr.WeightageID, "AccountName": editprr.AccountName,
      "ProcessName": editprr.ProcessName, "SubStateName": editprr.SubStateName, "ScoreCAT1": editprr.Target1,
      "ScoreCAT2": editprr.Target2, "ScoreCAT3": editprr.Target3, "ModifiedBy": loginId
   }

   return axios.post(api_url + '/WeightageMaster/EditWeightage', payload, { headers })

}

export const AddWeightage = (Addprr: WeightageVM, loginId: any) => {
   const payload = {
      "AccountName": Addprr.AccountName, "ProcessName": Addprr.ProcessName, "SubStateName": Addprr.SubStateName,
      "ScoreCAT1": Addprr.Target1, "ScoreCAT2": Addprr.Target2, "ScoreCAT3": Addprr.Target3,
      "CreatedBy": loginId
   }

   return axios.post(api_url + '/WeightageMaster/AddWeightage', payload, { headers })

}

export const DeleteWeightage = (WeightageID: number) => {
   return axios.post(api_url + '/WeightageMaster/DeleteWeightAge?weightageid=' + WeightageID)
}

export const GetSubStateProcess = (Processname: string) => {
   return axios.get(api_url + '/WeightageMaster/GetProcessSubStateMapping?processName=' + Processname)
}